module.exports = __webpack_public_path__ + "static/media/squad.f5b32f06.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/squad.png
// module id = 116
// module chunks = 0